import React, { createContext, useContext, useState, FC } from 'react';

export type ErrorAlert = {
  readonly title: string;
  readonly text?: ReadonlyArray<string>;
};

interface ErrorContextType {
  readonly errorMessages: ErrorAlert | null;
  readonly setErrorMessageAlert: (messages: ErrorAlert | null) => void;
}

export const ErrorContext = createContext<ErrorContextType | undefined>(
  undefined,
);
export const useErrorContext = () => {
  const context = useContext(ErrorContext);

  if (!context) {
    throw new Error(
      'useErrorContext must be used within a ErrorContextProvider',
    );
  }
  return context;
};

export const ErrorProvider: FC = ({ children }) => {
  const [errorMessages, setErrorMessages] = useState<ErrorAlert | null>(null);

  const setErrorMessageAlert = (message: ErrorAlert | null) => {
    setErrorMessages(message);
  };

  return (
    <ErrorContext.Provider value={{ errorMessages, setErrorMessageAlert }}>
      {children}
    </ErrorContext.Provider>
  );
};
